<template>
  <div class="studentCreate">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'student', params: {} }">
        Student
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'studentCreate', params: {} }">
        Create Student
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>Create Student</v-card-title>
      <v-card-text>
        <student-form :siblingId="siblingId"></student-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import StudentForm from "./StudentForm.vue";

export default {
  name: "student",
  data: () => {
    return {
      siblingId: null
    }
  },
  components: {
    StudentForm
  },
  created() {
    this.siblingId = this.$route.query.siblingId
    this.$emit("showParent", false);
  }
};
</script>
